<template>
  <div>
    <NavBar />
    <Create :create="createItem" :close="closeCreate"></Create>
    <Edit :item="currentItem" :update="updateItem" :close="closeEdit"></Edit>
    <div class="container">
      <SideBar />
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <h1 class="title">
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 495.212 495.212"
              style="enable-background: new 0 0 495.212 495.212"
              xml:space="preserve"
            >
              <g id="XMLID_415_">
                <path
                  id="XMLID_417_"
                  d="M171.492,96.586c26.688,0,48.314-21.616,48.314-48.288c0-26.679-21.626-48.295-48.314-48.295 c-26.67,0-48.276,21.616-48.276,48.295C123.216,74.97,144.823,96.586,171.492,96.586z"
                />
                <path
                  id="XMLID_416_"
                  d="M445.941,48.5L348.798,1.592c-3.811-1.847-8.229-2.096-12.23-0.7c-4.032,1.402-7.328,4.339-9.168,8.164 l-28.026,58.04c-3.86,7.972-0.503,17.558,7.468,21.405l37.408,18.063l-27.884,57.696l-52.64,23.88l-31.689-69.458 c-3.583-7.873-11.506-12.343-19.656-12.006h-81.776c-8.15-0.337-16.054,4.133-19.656,12.006L42.084,269.566 c-4.731,10.374-0.16,22.632,10.229,27.366c10.457,4.762,22.638,0.122,27.369-10.214l33.267-72.909 c0,8.681-0.061,92.467-0.061,256.621c0,13.691,11.101,24.783,24.786,24.783c13.697,0,24.786-11.092,24.786-24.783V322.727h18.072 V470.43c0,13.691,11.101,24.783,24.786,24.783c13.697,0,24.786-11.092,24.786-24.783c0-133.18-0.068-216.322-0.068-256.621 l4.682,10.23c3.468,7.591,10.972,12.086,18.816,12.086c2.834,0,5.744-0.598,8.517-1.856l26.271-11.924l-0.099,0.224 c-2.988,6.164-0.405,13.571,5.763,16.548c1.725,0.84,3.566,1.236,5.37,1.236c4.615,0,9.04-2.575,11.168-7.005l13.04-26.985 l13.845-6.288c10.39-4.709,14.986-16.949,10.278-27.341c-1.165-2.549-2.792-4.737-4.73-6.544l23.589-48.845l37.421,18.066 c3.823,1.847,8.229,2.099,12.249,0.703c4.02-1.405,7.309-4.342,9.168-8.164l28.008-58.044 C457.25,61.933,453.906,52.348,445.941,48.5z"
                />
              </g>
            </svg>
            Propagandas
          </h1>
          <ul class="tabs">
            <li class="tab-active">
              <router-link to="/propaganda">Dados</router-link>
            </li>
            <li>
              <!-- <router-link to="/propaganda/bg">Background</router-link> -->
            </li>
          </ul>
          <div class="card">
            <div class="card-body">
              <form class="form-single" v-on:submit.prevent="onSubmit">
                <div class="row">
                  <div class="col-1-2">
                    <div class="form-group">
                      <label for>Título</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="item.titulo"
                      />
                      <div class="message">
                        {{ validation.firstError("item.titulo") }}
                      </div>
                      <br />
                      <button class="button button-success">Alterar</button>
                    </div>
                  </div>
                  <div class="col-1-2">
                    <div class="form-group">
                      <label for>Subtitulo</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="item.subTitulo"
                      />
                      <div class="message">
                        {{ validation.firstError("item.subTitulo") }}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      <span class="aligned-row">
                        Desktop
                        <img
                          style="margin-left: 8px"
                          width="22px"
                          src="/images/computer.svg"
                        />
                      </span>
                    </th>
                    <th>
                      <span class="aligned-row">
                        Mobile
                        <img
                          style="margin-left: 8px"
                          width="22px"
                          src="/images/smartphone.svg"
                        />
                      </span>
                    </th>
                    <th>Ativo</th>
                    <th>Link</th>
                    <th>Ordem</th>
                    <th>
                      <button
                        class="button button-success button-sm button-block"
                        v-on:click="openCreate()"
                      >
                        <svg
                          style="width: 12px; height: 12px; fill: #fff"
                          x="0px"
                          y="0px"
                          viewBox="0 0 42 42"
                        >
                          <path
                            d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"
                          />
                        </svg>
                        Novo
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(i, index) in item.imagens" v-bind:key="index">
                    <!-- Imagem Desktop -->
                    <td>
                      <div class="imgbox" v-if="i.img">
                        <span>
                          <button
                            class="button button-error button-sm"
                            v-on:click="deleteImg(index, 'img')"
                          >
                            <svg
                              style="
                                margin-top: 4px;
                                width: 12px;
                                height: 12px;
                                fill: #fff;
                              "
                              x="0px"
                              y="0px"
                              viewBox="0 0 459 459"
                            >
                              <g>
                                <path
                                  d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
                                />
                              </g>
                            </svg>
                          </button>
                          <img v-if="i.img" :src="getImage(i.img)" />
                        </span>
                      </div>
                      <div class="imgbox" v-else>
                        <span>
                          <label class="button button-sm button-success">
                            <svg
                              style="
                                float: left;
                                width: 18px;
                                height: 18px;
                                fill: #fff;
                              "
                              x="0px"
                              y="0px"
                              viewBox="0 0 612 612"
                            >
                              <g>
                                <path
                                  d="M494.7,255C476.85,168.3,400.35,102,306,102c-73.95,0-137.7,40.8-168.3,102C58.65,214.2,0,277.95,0,357 c0,84.15,68.85,153,153,153h331.5c71.4,0,127.5-56.1,127.5-127.5C612,316.2,558.45,260.1,494.7,255z M357,331.5v102H255v-102 h-76.5L306,204l127.5,127.5H357z"
                                />
                              </g>
                            </svg>
                            <input
                              type="file"
                              name="img"
                              style="display: none"
                              accept="image/jpg, image/jpeg, image/png, image/webp"
                              @change="handleUpload(index, 'img')"
                            />
                          </label>
                        </span>
                      </div>
                    </td>

                    <!-- Imagem Mobile -->
                    <td>
                      <div class="imgbox" v-if="i.imgMobile">
                        <span>
                          <button
                            class="button button-error button-sm"
                            v-on:click="deleteImg(index, 'imgMobile')"
                          >
                            <svg
                              style="
                                margin-top: 4px;
                                width: 12px;
                                height: 12px;
                                fill: #fff;
                              "
                              x="0px"
                              y="0px"
                              viewBox="0 0 459 459"
                            >
                              <g>
                                <path
                                  d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
                                />
                              </g>
                            </svg>
                          </button>
                          <img
                            v-if="i.imgMobile"
                            :src="getImage(i.imgMobile)"
                          />
                        </span>
                      </div>
                      <div class="imgbox" v-else>
                        <span>
                          <label class="button button-sm button-success">
                            <svg
                              style="
                                float: left;
                                width: 18px;
                                height: 18px;
                                fill: #fff;
                              "
                              x="0px"
                              y="0px"
                              viewBox="0 0 612 612"
                            >
                              <g>
                                <path
                                  d="M494.7,255C476.85,168.3,400.35,102,306,102c-73.95,0-137.7,40.8-168.3,102C58.65,214.2,0,277.95,0,357 c0,84.15,68.85,153,153,153h331.5c71.4,0,127.5-56.1,127.5-127.5C612,316.2,558.45,260.1,494.7,255z M357,331.5v102H255v-102 h-76.5L306,204l127.5,127.5H357z"
                                />
                              </g>
                            </svg>
                            <input
                              type="file"
                              name="img"
                              style="display: none"
                              accept="image/jpg, image/jpeg, image/png, image/webp"
                              @change="handleUpload(index, 'imgMobile')"
                            />
                          </label>
                        </span>
                      </div>
                    </td>
                    <td>
                      <span class="label success" v-if="i.ativo">Ativo</span>
                      <span class="label" v-else>Inativo</span>
                    </td>
                    <td>{{ i.link }}</td>
                    <td>{{ i.ordem }}</td>
                    <td class="actions">
                      <a
                        class="button button-primary"
                        v-on:click="openEdit(index)"
                      >
                        <svg
                          x="0px"
                          y="0px"
                          style="
                            margin-top: 4px;
                            width: 12px;
                            height: 12px;
                            fill: #fff;
                          "
                          viewBox="0 0 485.219 485.22"
                        >
                          <g>
                            <path
                              d="M467.476,146.438l-21.445,21.455L317.35,39.23l21.445-21.457c23.689-23.692,62.104-23.692,85.795,0l42.886,42.897 C491.133,84.349,491.133,122.748,467.476,146.438z M167.233,403.748c-5.922,5.922-5.922,15.513,0,21.436 c5.925,5.955,15.521,5.955,21.443,0L424.59,189.335l-21.469-21.457L167.233,403.748z M60,296.54c-5.925,5.927-5.925,15.514,0,21.44 c5.922,5.923,15.518,5.923,21.443,0L317.35,82.113L295.914,60.67L60,296.54z M338.767,103.54L102.881,339.421 c-11.845,11.822-11.815,31.041,0,42.886c11.85,11.846,31.038,11.901,42.914-0.032l235.886-235.837L338.767,103.54z M145.734,446.572c-7.253-7.262-10.749-16.465-12.05-25.948c-3.083,0.476-6.188,0.919-9.36,0.919 c-16.202,0-31.419-6.333-42.881-17.795c-11.462-11.491-17.77-26.687-17.77-42.887c0-2.954,0.443-5.833,0.859-8.703 c-9.803-1.335-18.864-5.629-25.972-12.737c-0.682-0.677-0.917-1.596-1.538-2.338L0,485.216l147.748-36.986 C147.097,447.637,146.36,447.193,145.734,446.572z"
                            />
                          </g>
                        </svg>
                      </a>
                      &nbsp;
                      <button
                        class="button button-error"
                        v-on:click="deleteItem(index)"
                      >
                        <svg
                          style="
                            margin-top: 4px;
                            width: 12px;
                            height: 12px;
                            fill: #fff;
                          "
                          x="0px"
                          y="0px"
                          viewBox="0 0 459 459"
                        >
                          <g>
                            <path
                              d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
                            />
                          </g>
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "simple-vue-validator";
import { get, post, put, del, uploadImage } from "@/helpers/apiRequest";
import { getImage } from "@/helpers/utils";
import Create from "./Create";
import Edit from "./Edit";

const url = "/propaganda";

export default {
  name: "config",
  components: {
    Create,
    Edit,
  },
  data() {
    return {
      loading: false,
      item: {
        _id: "",
        titulo: "",
        subTitulo: "",
        imagens: [],
      },
      currentItem: {
        link: "",
        ativo: "",
        img: "",
        imgMobile: "",
        ordem: 1,
      },
    };
  },
  validators: {
    "item.titulo": (value) => Validator.value(value).required(),
    "item.subTitulo": (value) => Validator.value(value).required(),
  },
  methods: {
    getImage: getImage,
    fetchItems() {
      this.loading = true;
      get(url)
        .then((json) => {
          this.loading = false;
          this.item = json;
        })
        .catch((err) => console.log("err", err));
    },
    onSubmit() {
      this.$validate().then((success) => success && this.save());
    },
    save(novoItem = null) {
      this.loading = true;
      const isNew = !!novoItem;
      let message = isNew ? "Criado com Sucesso!" : "Alterado com Sucesso!";
      let oldItem = { ...this.item };
      if (isNew) {
        this.item.imagens.push(novoItem);
      }
      put(`${url}/${this.item._id}`, this.item)
        .then((json) => {
          this.$swal({ title: message, type: "success" });
        })
        .catch((err) => {
          this.item = { ...oldItem };
          this.$swal({ title: err.message, type: "error" });
        })
        .finally(() => {
          this.loading = false;
          this.fetchItems();
        });
    },
    deleteItem(index) {
      const { _id } = this.item;
      this.$swal({
        title: "Confirma Remover ?",
        showCancelButton: true,
        type: "error",
        confirmButtonColor: "#d82727",
      }).then(
        () => {
          this.loading = true;
          del(`${url}/${_id}/${index}`).then((json) => {
            this.item.imagens = this.item.imagens.filter(
              (_, k) => +index !== +k
            );
            this.loading = false;
          });
        },
        () => {}
      );
    },
    openCreate() {
      this.$modal.show("propagandaCreate");
    },
    closeCreate() {
      this.$modal.hide("propagandaCreate");
    },
    createItem(link, ativo, ordem, aba) {
      let novoItem = {
        link,
        ativo,
        ordem,
        aba,
      };

      this.save(novoItem);
    },
    openEdit(index) {
      const { link, ativo, ordem, aba, img, imgMobile } =
        this.item.imagens[index];
      this.loading = false;
      this.currentItem = Object.assign(
        {},
        {
          index,
          link,
          ativo,
          img,
          imgMobile,
          ordem,
          aba,
        }
      );
      this.$modal.show("propagandaEdit");
    },
    closeEdit() {
      this.currentItem = {
        link: "",
        ativo: "",
        img: "",
        imgMobile: "",
        ordem: "",
        aba: "",
      };
      this.loading = false;
      this.$modal.hide("propagandaEdit");
    },
    updateItem() {
      const { index, link, ativo, img, imgMobile, ordem, aba } =
        this.currentItem;
      this.item.imagens = this.item.imagens.map((i, k) => {
        if (+index === +k) {
          return { link, ativo, img, ordem, aba, imgMobile };
        }
        return i;
      });
      this.save();
      this.closeEdit();
    },
    handleUpload(index, key) {
      event.preventDefault();
      const settings = {
        el: event.target,
        str: `/nested/propaganda/imagens/${key}/${this.item._id}/${index}`,
        dim: "864x338",
      };
      this.loading = true;
      uploadImage(settings)
        .then(({ filename }) => {
          this.item.imagens = this.item.imagens.map((i, k) => {
            if (+index === +k) {
              i[key] = filename;
            }
            return i;
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteImg(index, key) {
      this.$swal({
        title: "Confirma Remover ?",
        showCancelButton: true,
        type: "error",
        confirmButtonColor: "#d82727",
      }).then(
        () => {
          this.loading = true;
          del(
            `/upload/nested/propaganda/imagens/${key}/${this.item._id}/${index}`
          )
            .then((json) => {
              this.item.imagens = this.item.imagens.map((i, k) => {
                if (+index === +k) {
                  i[key] = "";
                }
                return i;
              });
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
            });
        },
        () => {}
      );
    },
  },
  beforeMount() {
    this.fetchItems();
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Propaganda/Propaganda.vue